var isNumber=require("./isNumber");function isNaN(r){return isNumber(r)&&r!=+r}module.exports=isNaN;